<template>
  <div id="table-wrap">
    <el-table
      :ref="refName"
      :show-header="showHeader"
      :data="tableData"
      :header-cell-style="tableHeaderColor"
      :height="tableHeight"
      @row-click="rowClick"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        v-if="selectCtrl"
        width="50"
      >
      </el-table-column>

      <el-table-column
        v-for="{ prop, label, width, btn, obj } in tableProps"
        :align="align"
        show-overflow-tooltip
        :prop="prop"
        :key="prop"
        :label="label"
        :fixed="
          prop === 'handle' ||
          prop === 'giftHandle' ||
          prop === 'giftDetailsHandle'
            ? 'right'
            : false || prop === 'cardDetailsHandle'
            ? 'right'
            : false
        "
        :width="width"
      >
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span v-if="prop === 'useinfo.lastTime'">{{
              scope.row | filterObj(prop) | filterDate
            }}</span>
            <span v-else-if="prop === 'useinfo.enable'">{{
              scope.row | filterObj(prop) ? "是" : "否"
            }}</span>
            <span v-else-if="prop === 'detail.value'">
              <span
                v-if="scope.row.detail.parent && scope.row.detail.parent.length"
              >
                {{
                  `${scope.row.detail.parent[0].value} / ${scope.row.detail.value}`
                }}
              </span>
              <span v-else>{{ scope.row | filterObj(prop) }}</span>
            </span>
            <span v-else>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div
            class="omitText"
            v-else-if="
              prop === 'updated_at' ||
                prop === 'created_at' ||
                prop === 'createdAt' ||
                prop === 'updatedAt' ||
                prop === 'publishAt' ||
                prop === 'endAt' ||
                prop === 'pay_time' ||
                prop === 'liveAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <div v-else-if="prop === 'tagsFunct'" class="omitText">
            <template v-if="getTagsCategory(scope.row['tags'], 'funct').length">
              <span
                v-for="(item, index) in getTagsCategory(
                  scope.row['tags'],
                  'funct'
                )"
                :key="item.key"
              >
                {{ `${item.parent[0].value} / ${item.value}` }}
                <span
                  v-if="
                    index !==
                      getTagsCategory(scope.row['tags'], 'funct').length - 1
                  "
                  >、</span
                >
              </span>
            </template>
            <span v-else>-</span>
          </div>
          <div v-else-if="prop === 'tagsCate'" class="omitText">
            <template v-if="getTagsCategory(scope.row['tags'], 'cate').length">
              <span
                v-for="(item, index) in getTagsCategory(
                  scope.row['tags'],
                  'cate'
                )"
                :key="item.key"
              >
                {{ `${item.parent[0].value} / ${item.value}` }}
                <span
                  v-if="
                    index !==
                      getTagsCategory(scope.row['tags'], 'cate').length - 1
                  "
                  >、</span
                >
              </span>
            </template>
            <span v-else>-</span>
          </div>
          <div v-else-if="prop === 'tagsRet'" class="omitText">
            <template v-if="getTagsCategory(scope.row['tags'], 'ret').length">
              <span
                v-for="(item, index) in getTagsCategory(
                  scope.row['tags'],
                  'ret'
                )"
                :key="item.key"
              >
                {{ `${item.parent[0].value} / ${item.value}` }}
                <span
                  v-if="
                    index !==
                      getTagsCategory(scope.row['tags'], 'ret').length - 1
                  "
                  >、</span
                >
              </span>
            </template>
            <span v-else>-</span>
          </div>

          <div v-else-if="prop === 'handle'">
            <span v-for="item in btn" :key="item">
              <span :class="btnStyle(item)" @click="tableHandle(item, scope)">{{
                item
              }}</span>
            </span>
          </div>

          <div class="omitText" v-else-if="prop === 'uploadFileUrl'">
            <span
              v-if="scope.row[prop]"
              class="tags-linkUrl"
              @click.stop="openLink(scope.row.uploadFileUrl)"
            >
              打开
            </span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'appName'">
            <span
              v-if="scope.row[prop]"
              class="tags-linkUrl"
              @click.stop="openLink(scope.row.appName)"
            >
              {{ scope.row.appName }}
            </span>
            <span v-else>-</span>
          </div>

          <span v-else class="omitText">{{
            scope.row[prop] && scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "@/mixins/resize";
import DelPopup from "@/components/delPopup";

export default {
  components: {
    DelPopup
  },
  computed: {
    ...mapGetters(["hasData", "delPopup", "userInfo"]),
    labelNo() {
      return this.$t("commonMsg.No");
    }
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: "appTable"
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    tableWidth: {
      type: String,
      default: "width:100%"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array
    },
    selectCtrl: {
      type: Boolean,
      default: false
    },
    orderCtrl: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    expand: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: "center"
    },
    pageSize: Number
  },

  data() {
    return {
      selectDataIds: [],
      selectData: [],
      scopeItem: null
    };
  },

  filters: {
    filterObj(obj, value) {
      let arr = value.split(".");
      let val = {};
      for (let item of arr) {
        if (!Object.keys(val).length) {
          if (!obj[item]) {
            val = "-";
            break;
          } else {
            val = obj[item];
          }
        } else {
          if (!val[item]) {
            val = "-";
            break;
          } else {
            val = val[item];
          }
        }
      }
      return val;
    }
  },

  methods: {
    getTagsCategory(data, type) {
      let arr = data.filter(item => item.category === type);
      return arr || [];
    },
    openLink(link) {
      window.open(link, "__blank");
    },
    tableRowClassName() {
      return "statistics-row-className";
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    rowClick(row) {
      this.tableHandle(this.$t("commonMsg.checkDetails"), { row });
    },

    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.checkDetails"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
        case this.$t("commonMsg.remove"):
        case this.$t("commonMsg.destroy"):
        case this.$t("commonMsg.correction"):
        case this.$t("sale.gift.handle"):
        case "Token失效":
        case "笔记PDF修正":
        case "OSS查询":
        case "CB查询":
          className = "delBtn";

          break;

        default:
          break;
      }
      return className;
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      if (type === this.$t("commonMsg.del")) {
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delPopup");
      } else {
        this.emitEvn(type, scope, "tableHandle");
      }
    },

    //  确认删除
    deleteHandle() {
      this.emitEvn(this.$t("commonMsg.del"), this.scopeItem, "tableHandle");
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type || "",
        data: scope
      };
      this.$emit(evn, obj);
    },

    handleSelectionChange(data) {
      this.$emit("tableSelection", data);
    }
  }
};
</script>

<style lang="scss">
#table-wrap {
  height: calc(100% - 40px);
  .demo-table-expand {
    label {
      width: 90px;
    }
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 50%;
    }
  }

  .appTable-move {
    > i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }
    .move-up {
      background: url("~@/assets/img/cmb_move_up.png") no-repeat;
    }
    .move-down {
      background: url("~@/assets/img/cmb_move-down.png") no-repeat;
    }
  }
  .green {
    color: green;
  }
  .statistics-row-className {
    cursor: pointer;
  }
  .tags-linkUrl {
    cursor: pointer;
    color: #bf735b;
  }
}
</style>
